/* Arregla las estrellas de las reseñas de Revie.

   PROBLEMA: Revie dibuja las estrellas con <use href="#id"> apuntando a un <path>
   dentro de <defs>. En esta tienda esa referencia no se resuelve y las estrellas
   quedan invisibles (el hueco está, pero no se pinta nada). Pasa igual en el tema
   anterior, así que es un fallo del widget, no del tema.

   SOLUCIÓN: sustituir cada <use> por el <path> real, conservando su posición.
   Es idempotente y no toca nada más de la página.

   Si Revie lo corrige de su lado, este archivo puede eliminarse sin consecuencias.
*/
(function () {
  var NS = 'http://www.w3.org/2000/svg';

  function arreglar(svg) {
    if (svg.dataset.estrellasArregladas) return;
    var def = svg.querySelector('defs path[id]');
    if (!def) return;
    var d = def.getAttribute('d');
    if (!d) return;

    var usos = svg.querySelectorAll('use');
    if (!usos.length) return;

    Array.prototype.forEach.call(usos, function (u) {
      var p = document.createElementNS(NS, 'path');
      p.setAttribute('d', d);
      var x = u.getAttribute('x');
      var y = u.getAttribute('y');
      if (x || y) {
        p.setAttribute('transform', 'translate(' + (x || 0) + ',' + (y || 0) + ')');
      }
      if (u.parentNode) u.parentNode.replaceChild(p, u);
    });

    svg.dataset.estrellasArregladas = '1';
  }

  function revisar() {
    document.querySelectorAll('svg.rvst-stars').forEach(arreglar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revisar);
  } else {
    revisar();
  }

  // El widget puede inyectarse después de cargar la página.
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function () { revisar(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 15000);
  }
})();
